/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateDmSettingsBody
 */
export interface UpdateDmSettingsBody {
    /**
     * Mute notifications for this conversation
     * @type {boolean}
     * @memberof UpdateDmSettingsBody
     */
    isMuted?: boolean;
    /**
     * Archive/hide this conversation
     * @type {boolean}
     * @memberof UpdateDmSettingsBody
     */
    isArchived?: boolean;
    /**
     * Block this user from sending DMs
     * @type {boolean}
     * @memberof UpdateDmSettingsBody
     */
    isBlocked?: boolean;
}

/**
 * Check if a given object implements the UpdateDmSettingsBody interface.
 */
export function instanceOfUpdateDmSettingsBody(value: object): value is UpdateDmSettingsBody {
    return true;
}

export function UpdateDmSettingsBodyFromJSON(json: any): UpdateDmSettingsBody {
    return UpdateDmSettingsBodyFromJSONTyped(json, false);
}

export function UpdateDmSettingsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDmSettingsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'isMuted': json['isMuted'] == null ? undefined : json['isMuted'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'isBlocked': json['isBlocked'] == null ? undefined : json['isBlocked'],
    };
}

export function UpdateDmSettingsBodyToJSON(json: any): UpdateDmSettingsBody {
    return UpdateDmSettingsBodyToJSONTyped(json, false);
}

export function UpdateDmSettingsBodyToJSONTyped(value?: UpdateDmSettingsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isMuted': value['isMuted'],
        'isArchived': value['isArchived'],
        'isBlocked': value['isBlocked'],
    };
}

